import { render, staticRenderFns } from "./LoanTransDetails.vue?vue&type=template&id=156a177e&scoped=true"
import script from "./LoanTransDetails.vue?vue&type=script&lang=js"
export * from "./LoanTransDetails.vue?vue&type=script&lang=js"
import style0 from "./LoanTransDetails.vue?vue&type=style&index=0&id=156a177e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a177e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156a177e')) {
      api.createRecord('156a177e', component.options)
    } else {
      api.reload('156a177e', component.options)
    }
    module.hot.accept("./LoanTransDetails.vue?vue&type=template&id=156a177e&scoped=true", function () {
      api.rerender('156a177e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/LoanTransDetails.vue"
export default component.exports